import './vendor/modernizr';
import { AnimateObserver } from './lib/animate-observer';
import Alpine from 'alpinejs'
import { Accordion } from './lib/accordion';
import { Menu } from './lib/menu';
import { Nav } from './lib/nav';
import { Notice } from './lib/notice';
import collapse from '@alpinejs/collapse'
import Clipboard from "@ryangjchandler/alpine-clipboard"
import intersect from '@alpinejs/intersect'
import { Sticky } from './lib/sticky';

if ( document.querySelector( '.js-video' ) ) {
    const players = Array.from( document.querySelectorAll('.js-video') );

    import('plyr').then( module => {
        players.forEach( $el => {
            const player = new module.default($el);
        });
    });
}

window.Accordion = Accordion;
window.Menu = Menu;
window.Nav = Nav;
window.Notice = Notice;
window.Alpine = Alpine

Alpine.plugin(Clipboard)
Alpine.plugin(collapse)
Alpine.plugin(intersect)
Alpine.start()

//const background = new Background('body');
//background.init();

if ( document.querySelector( '.js-height' ) ) {
    import('./lib/height').then( module => {
        const height = new module.Height();
        height.init();
    } );
}

if ( document.querySelector( '.js-scroller' ) ) {
    import('./lib/scroller').then( module => {
        const scroll = new module.Scroller();
        scroll.init();
    } );
}

if ( document.querySelector( '.js-carousel' ) ) {
    import('./lib/carousel').then( module => {
        const carousel = new module.Carousel();
        carousel.init();
    });
}

Alpine.plugin(Clipboard.configure({
    onCopy: () => {
        console.log('Copied!')
    }
}));

const animate = new AnimateObserver();
animate.init();

const sticky = new Sticky();
sticky.init();

// Initialize notice banner
if (document.querySelector('.c-notice')) {
    const notice = new Notice();
}
